import { render, staticRenderFns } from "./ClientDataTab.vue?vue&type=template&id=3e1069bc"
import script from "./ClientDataTab.vue?vue&type=script&lang=js"
export * from "./ClientDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports